export default "__VITE_ASSET__DTmdRl94__"